/*
 * Modal for adding and editing UI Configurations
 */

define(["marionette", "messaging/messenger", "./uiConfigModalView"], function (
  Marionette,
  Messenger,
  UIConfigModalView,
) {
  var UIConfigModalController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "uiConfigModal";
      this.region = options.region;
    },
    show: function (uiConfig) {
      //create a backup just in case we need to revert
      var backupConfig = uiConfig.clone();
      this.view = new UIConfigModalView.uiConfigModalView({ model: uiConfig });

      //fetch a new password(key) if the config is new
      if (uiConfig.isNew()) {
        uiConfig.generatePassword();
      }

      //if validation fails, display an error
      uiConfig.on(
        "invalid",
        function (model, error) {
          if ("name" in error) {
            this.view.nameError(error["name"]);
          }
          if ("contextIds" in error) {
            this.view.contextsError(error["contextIds"]);
          }
        },
        this,
      );

      this.view.on(
        "done",
        function () {
          //update the model by pulling the values from the form elements (name is already applied by the textbox)
          this.view.applyFormToModel();
          //make sure that any textboxes can be closed before trying to save
          if (Messenger.reqres.request("save:textbox")) {
            //save the input (will throw a validation error if the attributes are bad)
            uiConfig.saveModel({
              success: function () {
                Messenger.vent.trigger("close:modal");
              },
              error: function (model, response) {
                Messenger.showErrorFromResponse(response);
              },
            });
          }
        },
        this,
      );

      this.view.on(
        "cancel",
        function () {
          Messenger.vent.trigger("cancel:textbox"); //cancel any open textboxes
          if (uiConfig.isNew()) {
            uiConfig.deleteModel();
          } else {
            //revent any changes
            uiConfig.set(backupConfig.attributes);
          }
          Messenger.vent.trigger("close:modal");
        },
        this,
      );

      this.showRegion(this.view);
    },
  });

  return UIConfigModalController;
});
